import { render, staticRenderFns } from "./ExpertEditor.vue?vue&type=template&id=39678510&scoped=true"
import script from "./ExpertEditor.vue?vue&type=script&lang=js"
export * from "./ExpertEditor.vue?vue&type=script&lang=js"
import style0 from "./ExpertEditor.vue?vue&type=style&index=0&id=39678510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39678510",
  null
  
)

export default component.exports